import { AfterViewInit, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';

const maxHeight = window.innerHeight / 3;

@Component({
  selector: 'ins-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit, AfterViewInit {
  @HostBinding('class.dropdown-list')
  @Input('dropdown-list')
  dropdownList = false;

  @Input()
  @HostBinding('class.shadow')
  shadow = true;

  @Input()
  @HostBinding('class.has-padding')
  padding = true;

  @Input() scrollBar = false;

  @Input() scrollBottom = false;

  @HostBinding('style.max-height.px') dropdownHeight: number;

  @HostBinding('style.overflow-y') showScroll = '';

  constructor(public element: ElementRef) {}

  ngOnInit() {
    if (this.scrollBar) {
      this.showScroll = 'auto';
      this.dropdownHeight = maxHeight;
    }
  }

  ngAfterViewInit(): void {
    if (this.scrollBottom) {
      this.element.nativeElement.scrollTop = this.element.nativeElement.scrollHeight;
    }
  }
}
